import { AppThunk } from '../states/generateStore';
import { suiteCrmUrl, checkEmailLead } from './constants';
import dialogSlice from '../states/dialog/slice';
import shellSlice from '../states/shell/slice';
import snackBarSlice from '../states/snackbar/slice';

const onCheckEmailLead = (emailInfo: string): AppThunk =>
  async (dispatch, getStore) => {
    // Create a fetch call to check email lead
    try {
      // show loading
      dispatch(shellSlice.actions.updateLeadDataIsLoading(true));

      const formData = new FormData();
      formData.append('email_info', emailInfo);

      const response = await fetch(suiteCrmUrl.concat(checkEmailLead),
        { 
          method: 'POST',
          body: formData
        }
      );
      const result = await response.json();
      if (result.hasOwnProperty('id')) {
        // save to Lead state
        dispatch(shellSlice.actions.updateLeadState(result));
        // hide loading
        dispatch(shellSlice.actions.updateLeadDataIsLoading(false));

        // content builder
        let content = "This email has exist on our system:\n\n"
          .concat("First name: " + result.first_name + "\n")
          .concat("Last name: " + result.last_name + "\n")
          .concat("Phone number: " + result.mobile_phone_c + "\n")
          .concat("Address: " + result.billing_address_street + "\n")
          .concat("State: " + result.billing_address_state + "\n")
          .concat("Localy: " + result.billing_address_city + "\n")
          .concat("Postcode: " + result.billing_address_postalcode + "\n\n")
          .concat("Do you want to use this info or create new?")

        dispatch(dialogSlice.actions.updateDialogInfo({message: content, title: 'Confirm Dialog', name: 'email-confirm'}));
        dispatch(dialogSlice.actions.updateDialog(true));
      } else {
        // hide loading
        dispatch(shellSlice.actions.updateLeadDataIsLoading(false));
      }
    } catch (err) {
      console.log(err);
      
      // show error
      dispatch(snackBarSlice.actions.updateAlert({message: "onCheckEmailLead: Can not get data from Server", severity: "error"}));
      dispatch(snackBarSlice.actions.updateSnackBar(true));
    }
  }
export default onCheckEmailLead;